<template>
    <div class="rank-distribute flow-container">
        <ParamsHeader :data-conf="{ type: 'month' }" @searchParams="searchData"></ParamsHeader>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header" style="position: relative">
                    <span>商场排行</span>
                    <div style="width: 100%; position: absolute; background-color: transparent; text-align: center">
                        <el-radio-group v-model="rankType" @change="handleRadio">
                            <el-radio label="DataIn">客流</el-radio>
                            <el-radio label="FlowDensity">集客力</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </template>
            <div v-if="tableData" style="display: flex; margin-top: 10px">
                <div style="flex: 6; margin-right: 10px">
                    <el-row class="rank">
                        <el-col :span="12">客流TOP5</el-col>
                        <el-col :span="6">客流(人次)</el-col>
                        <el-col :span="6">环比</el-col>
                    </el-row>
                    <el-row v-for="(item, index) in myTableData['asc']" :key="item.Name" class="rank">
                        <el-col :span="12">
                            <el-badge :value="index + 1" type="warning" :class="{ item: index > 2 }"></el-badge>
                            &nbsp;&nbsp;{{ item.Name }}
                        </el-col>
                        <el-col :span="6">{{ item[rankType] }}</el-col>
                        <el-col :span="6" style="color: red"><i class="el-icon-bottom"></i>&nbsp;&nbsp;85%</el-col>
                    </el-row>
                </div>
                <div style="flex: 6">
                    <el-row class="rank">
                        <el-col :span="12">客流BOTTOM5</el-col>
                        <el-col :span="6">客流(人次)</el-col>
                        <el-col :span="6">环比</el-col>
                    </el-row>
                    <el-row v-for="(item, index) in myTableData['desc']" :key="item.Name" class="rank">
                        <el-col :span="12">
                            <el-badge :value="index + 1" type="warning" :class="{ item: index > 2 }"></el-badge>
                            &nbsp;&nbsp;{{ item.Name }}
                        </el-col>
                        <el-col :span="6">{{ item[rankType] }}</el-col>
                        <el-col :span="6" style="color: red"><i class="el-icon-bottom"></i>&nbsp;&nbsp;85%</el-col>
                    </el-row>
                </div>
            </div>
        </Card>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>详细数据</span>
                    <div class="buttons">
                        <el-button icon="el-icon-delete" size="mini" type="primary"> 导出数据 </el-button>
                    </div>
                </div>
            </template>
            <list-page
                v-if="searchParam"
                @complete="handleComplete"
                :showTitle="false"
                :api="searchUrl"
                :searchParam="searchParam"
                :showPager="false"
                :showSearch="false"
                ref="listPage"
            >
                <el-table-column type="index" width="80px" label="序号"></el-table-column>
                <el-table-column prop="Name" label="名称"></el-table-column>
                <el-table-column prop="DataIn" label="客流量（人次）"></el-table-column>
                <el-table-column prop="FlowDensity" label="集客力(人/㎡)"></el-table-column>
            </list-page>
        </Card>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader2";

export default {
    name: "rankAnalysis",
    components: {
        ParamsHeader,
    },
    computed: {
        myTableData() {
            if (!this.tableData) return { asc: [], desc: [] };
            let data = [...this.tableData];
            let obj = { asc: [], desc: [] };
            for (let i = 0; i < 5 && i < data.length; i++) {
                obj["asc"].push(data[i]);
            }
            for (let i = data.length - 1, y = 0; y < 5 && i > -1; i--) {
                obj["desc"].push(data[i]);
            }
            return obj;
        },
    },
    data() {
        return {
            rankType: "DataIn",
            searchUrl: "/AnalyzeData/GetShopRank",
            searchParam: null,
            tableData: null,
        };
    },
    methods: {
        searchData(params) {
            let searchParams = {
                BeginTime: this.$dayjs(params.Date).startOf("month").format("YYYY-MM-DD"),
                EndTime: this.$dayjs(params.Date).endOf("month").format("YYYY-MM-DD"),
                Type: 2,
                ID: params.EntityID,
            };
            this.searchParam = { ...searchParams };
            this.$nextTick(() => {
                if (this.tableData) {
                    this.$refs["listPage"].searchData();
                }
            });
        },
        handleRadio(value) {
            this.tableData = [...this.tableData.sort((first, second) => first[value] - second[value])];
        },
        handleComplete(data) {
            this.tableData = [...data];
            this.$forceUpdate();
        },
    },
};
</script>

<style scoped>
.rank :deep(.el-col) {
    padding: 10px;
}
.item :deep(.el-badge__content--warning) {
    background-color: transparent;
    color: #333333;
    font-size: 16px;
    padding-top: 3px;
}
</style>
